function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { uuid } from 'uuidv4';
import { DateTime } from 'luxon';
import MotoEntry from './MotoEntry';
import RiderEntry from './RiderEntry';
import Photo from './Photo';
var TABLE = 'log_book_entry';
var COLUMNS = ['id', 'event', 'riders', 'venue', 'date', 'submitted_to_usa_bmx', 'json'];

var LogBookEntry = /*#__PURE__*/function () {
  _createClass(LogBookEntry, null, [{
    key: "allIds",
    value: function allIds(storage) {
      return storage.all(LogBookEntry.TABLE, ['id'], 'date', 'DESC').then(function (results) {
        return results.map(function (r) {
          return r.id;
        });
      });
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var logBookEntry = new LogBookEntry(JSON.parse(json));
      logBookEntry.date = DateTime.fromMillis(logBookEntry.date);
      logBookEntry.riderEntries = logBookEntry.riderEntries.map(function (entry) {
        var riderEntry = new RiderEntry(entry);
        riderEntry.photos = riderEntry.photos.map(function (photo) {
          return new Photo(photo);
        });
        riderEntry.motos = riderEntry.motos.map(function (moto) {
          var motoEntry = new MotoEntry(moto);
          motoEntry.photos = motoEntry.photos.map(function (photo) {
            return new Photo(photo);
          });
          return motoEntry;
        });
        return riderEntry;
      });
      return logBookEntry;
    }
  }, {
    key: "get",
    value: function get(storage, id) {
      return storage.getById(LogBookEntry.TABLE, id, ['json']).then(function (results) {
        return LogBookEntry.fromJSON(results[0].json);
      });
    }
  }, {
    key: "forRider",
    value: function forRider(storage, id) {
      return storage.like(LogBookEntry.TABLE, 'riders', id).then(function (results) {
        return results.map(function (r) {
          return LogBookEntry.fromJSON(r.json);
        });
      });
    }
  }, {
    key: "addOrUpdate",
    value: function addOrUpdate(storage, logBookEntry) {
      var riderEntries = logBookEntry.riderEntries,
          entryToStore = _objectWithoutProperties(logBookEntry, ["riderEntries"]);

      entryToStore.date = entryToStore.date.toMillis();
      entryToStore.riderEntries = logBookEntry.riderEntries.map(function (entry) {
        var entryCopy = _extends({}, entry);

        entryCopy.photos = entryCopy.photos.map(function (photo) {
          return {
            id: photo.id,
            parent: photo.parent
          };
        });
        entryCopy.motos = entryCopy.motos.map(function (moto) {
          var motoCopy = _extends({}, moto);

          motoCopy.photos = motoCopy.photos.map(function (photo) {
            return {
              id: photo.id,
              parent: photo.parent
            };
          });
          return motoCopy;
        });
        return entryCopy;
      });
      var riders = entryToStore.riderEntries.map(function (riderEntry) {
        return riderEntry.rider.id;
      }).join(',');
      var data = JSON.stringify(entryToStore);
      var columns = [];
      var values = [];

      if (entryToStore.event && entryToStore.event.id) {
        columns.push('event');
        values.push(entryToStore.event.id);
      }

      columns.push('riders');
      values.push(riders);

      if (entryToStore.venue && entryToStore.venue.id) {
        columns.push('venue');
        values.push(entryToStore.venue.id);
      }

      columns.push('date');
      values.push(entryToStore.date);
      columns.push('submitted_to_usa_bmx');
      values.push(entryToStore.submittedToUSABMX ? 1 : 0);
      columns.push('json');
      values.push(data);
      return storage.addOrUpdate(LogBookEntry.TABLE, logBookEntry.id, columns, values);
    }
  }, {
    key: "deleteTree",
    value: function deleteTree(storage, logBookEntry) {
      var promises = [];
      logBookEntry.riderEntries.forEach(function (entry) {
        entry.photos.forEach(function (photo) {
          promises.push(Photo.delete(storage, photo.id));
        });
        entry.motos.forEach(function (moto) {
          moto.photos.forEach(function (photo) {
            promises.push(Photo.delete(storage, photo.id));
          });
        });
      });
      promises.push(storage.deleteById(LogBookEntry.TABLE, logBookEntry.id));
      return Promise.all(promises);
    }
  }]);

  function LogBookEntry(props) {
    var _this = this;

    _classCallCheck(this, LogBookEntry);

    _defineProperty(this, "isPractice", function () {
      return _this.event.name === 'Practice' || _this.category === 'Practice' || _this.event.eventName && _this.event.eventName() === 'Practice';
    });

    _defineProperty(this, "addEntry", function () {
      var entry = new RiderEntry();
      entry.motos.push(new MotoEntry({
        name: 'm 1',
        number: '',
        finish: ''
      }));
      entry.motos.push(new MotoEntry({
        name: 'm 2',
        number: '',
        finish: ''
      }));
      entry.motos.push(new MotoEntry({
        name: 'm 3',
        number: '',
        finish: ''
      }));
      entry.motos.push(new MotoEntry({
        name: 'sixteenth',
        number: '',
        finish: ''
      }));
      entry.motos.push(new MotoEntry({
        name: 'eighth',
        number: '',
        finish: ''
      }));
      entry.motos.push(new MotoEntry({
        name: 'quarter',
        number: '',
        finish: ''
      }));
      entry.motos.push(new MotoEntry({
        name: 'semi',
        number: '',
        finish: ''
      }));
      entry.motos.push(new MotoEntry({
        name: 'main',
        number: '',
        finish: ''
      }));

      _this.riderEntries.push(entry);

      return entry;
    });

    _defineProperty(this, "removeEntry", function (entry) {
      var idx = _this.riderEntries.indexOf(entry);

      if (idx >= 0) {
        _this.riderEntries.splice(idx, 1);
      }
    });

    _defineProperty(this, "save", function (storage) {
      return LogBookEntry.addOrUpdate(storage, _this);
    });

    _defineProperty(this, "delete", function (storage) {
      return LogBookEntry.deleteTree(storage, _this);
    });

    this.id = uuid();
    this.submittedToUSABMX = false;
    this.date = DateTime.fromJSDate(new Date());
    this.venue = {
      id: undefined,
      name: undefined
    };
    this.event = {
      id: undefined,
      name: undefined
    };
    this.pointsClass = {
      name: 'No Points',
      id: 0
    };
    this.riderEntries = [];

    _extends(this, props);
  }

  return LogBookEntry;
}();

LogBookEntry.TABLE = TABLE;
LogBookEntry.COLUMNS = COLUMNS;
export default LogBookEntry;